<template lang="pug">
  label(:for="checkboxId" :class="labelClass").form-section-checkbox
    input(type="checkbox" :id="checkboxId" :disabled="disabled" :checked="value" :value="value" @input="onInput")
    .checkmark-wrap(:class="checkmarkClass")
      inline-svg(:src="require(`./check-mark.svg`)").checkmark
    span.form-section-checkbox__text {{ label }}
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import InlineSvg from "vue-inline-svg";

@Component({
  name: "PayoutFormCheckbox",
  components: {
    InlineSvg
  }
})
export default class PayoutFormCheckbox extends Vue {
  @Prop({default: false})
  disabled!: boolean;

  @Prop({default: false})
  value: boolean

  @Prop({default: ''})
  label!: string;

  _id = ''

  created() {
    this._id = Math.random().toString(36).substr(2, 9);
  }

  get checkboxId() {
    return 'checkbox-' + this._id;
  }

  get labelClass() {
    return {
      'label--active': !this.disabled,
      'label--disabled': this.disabled,
      'label--checked': this.value,
      'label--unchecked': !this.value,
    }
  }

  get checkmarkClass() {
    return {
      'checkmark-wrap--disabled': this.disabled,
      'checkmark-wrap--checked': this.value,
      'checkmark-wrap--unchecked': !this.value,
    };
  }

  onInput($event: any) {
    //console.log('checkbox input', $event.target.checked);
    if (!this.disabled)
      this.$emit('input', $event.target.checked);
  }
}
</script>

<style scoped lang="less">
.form-section-checkbox {

  display: grid;
  margin: 0;
  grid-gap: 10px;
  align-items: center;
  grid-template-columns: min-content;
  grid-auto-flow: column;
  grid-auto-columns: auto;

  user-select: none;

  &.label--active {
    cursor: pointer;
  }

  &.label--disabled {
    cursor: not-allowed;
    .form-section-checkbox__text {
      color: #d3d3d7;
    }
  }

  .checkmark-wrap {
    width: 18px;
    height: 18px;
    background: #d5d7e5;
    border-radius: 3px;
    svg.checkmark {
      fill: #fff;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    .checkmark {
      width: 60%;
      height: 60%;
    }
    &.checkmark-wrap--checked {
      background: #80bd1c;
      .checkmark {
        display: initial;
      }
    }
    &.checkmark-wrap--unchecked {
      .checkmark {
        display: none;
      }
    }
    &.checkmark-wrap--disabled {
      background: #d5d7e5;
      .checkmark {

      }
    }
  }

  .checkbox-icon {
    width: 18px;
    height: 18px;
  }
  .checkbox-icon--checked {
    fill: #80bd1c;
    transition: 0.3s;
  }
  .checkbox-icon--unchecked {
    //color: #d5d7e5;
    //background-color: #d5d7e5;
    fill: #d5d7e5;
    transition: 0.3s;
  }
}
</style>
